import { Component, computed, input, output } from '@angular/core';
import { RidFeedbackToast } from '../rid-feedback-toast/rid-feedback-toast';

export type TFeedbackComparisonChange = 'LOWER' | 'EQUAL' | 'HIGHER';

export interface TFeedbackComparisonConfig {
  better: 'LOWER' | 'HIGHER';
  formatTitle: (value: number) => string;
  formatDescription: (change: TFeedbackComparisonChange, difference: number) => string;
}

function compare(value: number, previousValue: number): TFeedbackComparisonChange {
  if (value === previousValue) return 'EQUAL';
  return value < previousValue ? 'LOWER' : 'HIGHER';
}

@Component({
  selector: 'rid-feedback-comparison-toast',
  imports: [RidFeedbackToast],
  templateUrl: './rid-feedback-comparison-toast.html',
  host: {
    class: 'contents',
  },
})
export class RidFeedbackComparisonToast {
  value = input.required<number>();
  previousValue = input<number>();
  config = input.required<TFeedbackComparisonConfig>();

  continued = output<void>();

  protected readonly title = computed(() => this.config().formatTitle(this.value()));

  protected readonly description = computed(() => {
    const previousValue = this.previousValue();
    if (previousValue === undefined) return '';

    const value = this.value();
    return this.config().formatDescription(compare(value, previousValue), Math.abs(value - previousValue));
  });

  protected readonly variant = computed<'SUCCESS' | 'INFO'>(() => {
    const previousValue = this.previousValue();
    if (previousValue === undefined) return 'INFO';

    return compare(this.value(), previousValue) === this.config().better ? 'SUCCESS' : 'INFO';
  });
}
